import { useEffect, useMemo, useState } from "react";
import { selectOpMode } from "../../../../../util/store/selectors";
import { getStore } from "../../../../../util/store/store";
import {
    OP_STATUS,
    SHORT_DATETIME_FORMAT,
    SHORT_TIME_FORMAT
} from "../../../../../util/varibles/constants";
import { IActivityLog } from "../../../../../util/varibles/interface";
import { generateListTime } from "../../constants";
import { callEventPopupOpInfo, getPopupOpInfo, usePopupOpInfo } from "../../PopupOpInfoContext";
import SupportOp from "../SupportOp";
import Vessel from "../Vessel";
import styles from './style.module.scss';
import Time from "./Time";

const classByType = [styles.state, styles.site, styles.factory, styles.state];

const ActivityLog: React.FC = () => {
    const [state, setState] = useState<{
        listTime: any
        activity_log: IActivityLog[]
    }>({
        listTime: [],
        activity_log: [],
    })

    const [data] = usePopupOpInfo(state => state.data);
    const getPopup = getPopupOpInfo();
    const { listTime, activity_log } = state;
    const { status, operation_type = "", related_id = "" } = data?.operation || {};
    const { updateActivityLog } = callEventPopupOpInfo();

    useEffect(() => {
        const opMode = selectOpMode(getStore());
        if (data?.operation) {
            const listTime = generateListTime[operation_type](data?.activity_log || [], opMode, data.operation)
            setState(prev => ({ ...prev, listTime, activity_log: data?.activity_log || [] }));
        }
    }, [data?.activity_log, data?.operation, operation_type])

    const handleChangeTime = (e: any, state: number) => {
        const { listTime, activity_log }: any = state;
        const newTime = e.valueOf();
        const oldTime = listTime[state].time;
        const duration = newTime - oldTime;
        let limit = 0;
        for (let i = 0; i < state; i++) {
            limit += (activity_log[i + 1].est_start_time - activity_log[i].est_start_time);
        }

        const newActivityLog = activity_log.reduce((list: any, item: any, index: number) => {
            if (index >= state) {
                return [...list, { ...item, est_start_time: item.est_start_time + duration }];
            }
            const limitTime = newTime - limit;
            if (index < state && limit)
                limit -= (activity_log[index + 1].est_start_time - activity_log[index].est_start_time);
            if (item.est_start_time >= limitTime)
                return [...list, { ...item, est_start_time: limitTime }];
            return [...list, item];
        }, [])

        const opMode = selectOpMode(getStore());
        const newListTime = generateListTime[operation_type](newActivityLog, opMode, data?.operation)

        setState(prev => ({ ...prev, listTime: newListTime, activity_log: newActivityLog }));
        updateActivityLog(newActivityLog);
    }

    const start = listTime[0]?.time || 0;
    const finish = listTime[listTime.length - 1]?.time || 0;
    const format = new Date(start).getDate() !== new Date(finish).getDate()
        ? SHORT_DATETIME_FORMAT
        : SHORT_TIME_FORMAT;

    const isEdit = useMemo(() => {
        const { isEdit } = getPopup();
        return isEdit && !(status === OP_STATUS.PROCESSING || status === OP_STATUS.FINISHED)
    }, [getPopup, status]);

    return <>
        <div className={styles['info-route']}>
            {data && (related_id.length > 0
                ? <SupportOp op={data.operation} vesselName={data.vessel?.name} onClose={getPopup()?.onClose} />
                : <div className={styles['route-time']}>
                    <Vessel vessel={data.vessel} operation={data.operation} max_point={activity_log.length} />
                    {listTime.map((item: any, index: number) => <div key={index} {...{
                        className: classByType[item.type],
                        style: { left: item.left },
                        title: item.title
                    }} />)}
                    <div className={styles['route-line']} />
                </div>)}
        </div>

        <div className={styles['container-times']}>
            <div className={styles['container-time-picker']} style={{ gridTemplateColumns: `repeat(${listTime.length}, 1fr)` }}>
                {listTime.map((item: any, i: number) =>
                    <Time key={i} timeDisabled={listTime[i - 1]} {...{
                        item,
                        isEdit: !!isEdit,
                        format,
                        handleChangeTime: (e: any) => handleChangeTime(e, i),
                    }} />
                )}
            </div>
        </div>
    </>;
}

export default ActivityLog
